import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../Modal/Modal';
import Navigation from '../Navigation';
import UnifiedNavigation from '../../UnifiedSidebar/UnifiedNavigation';
import { useIsUnifiedSidebarEnabled } from '../../../hooks/useIsUnifiedSidebarEnabled';
import { isNavigationOpenSelector } from '../../../redux/reducers/ui/modals';
import { hideNavigationModal } from '../../../redux/actions/ui/modals';
import styles from './NavigationModal.module.css';

const NavigationModal = () => {
  const dispatch = useDispatch();
  const { key } = useLocation();
  const isOpen = useSelector(isNavigationOpenSelector);

  useEffect(() => {
    dispatch(hideNavigationModal());
  }, [dispatch, key]);

  const isUnifiedSidebarEnabled = useIsUnifiedSidebarEnabled();
  const NavigationComponent = isUnifiedSidebarEnabled
    ? UnifiedNavigation
    : Navigation;

  return (
    <Modal
      isOpen={isOpen}
      className={styles['lc-modal']}
      overlayClassName={classNames(styles['lc-overlay'], {
        [styles.navigationOpen]: isOpen,
      })}
    >
      <NavigationComponent />
    </Modal>
  );
};

export default NavigationModal;
